/*ProgressBar*/
export const actionChangeStatusProgressBar = (status_progress_bar) => ({
    type: 'CHANGE_PROGRESS_BAR', payload: {status_progress_bar}
});

/*Menu*/
export const handelOpenMenuLeft = () => ({
    type: 'OPEN_MENU_LEFT'
});
export const handelCloseMenuLeft = () => ({
    type: 'CLOSE_MENU_LEFT'
});
